import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import "./testimonial.css";
import { Link } from 'react-router-dom';
import bg from "../../assets/images/About/bg-content.png";
import SEO from '../seo';
export default function About() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];
    return (
        <div>
            <SEO
                title="Testimonial"
                description="Testimonials Clients Reviews We value the experimentation, the reformation of the message, and the smart incentives. We offer a variety of services and solutions Worldwide. &quot;Working with this development team was a delight! They took Raveena Singh&#039;s vision and crafted a website that exceeded expectations. Their attention to detail and dedication to perfection truly set [&hellip;]"
                canonical="https://www.hwplindia.com/companay/testimonial/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Testimonial</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Company</li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Testimonial</li>
                    </ul>
                </div>
            </section>
            <section
                className="testimonial-page"
                style={{ backgroundImage: `url(${bg})` }}
            >
                <div className="auto-container">
                    {/* Sec Title */}
                    <div className="sec-title">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="left-box">
                                <div className="sec-title_title testimonial-title">Testimonials</div>
                                <h2 className="sec-title_heading">
                                    Clients Reviews
                                </h2>
                            </div>
                            <div className="right-box right-box-testimonial">
                                <div className="sec-title_text">
                                    We value the experimentation, the reformation of the message, and the smart incentives. We offer a variety of services and solutions Worldwide.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row clearfix">
                        {/* Testimonial Seven */}
                        <div className="testimonial-eight col-lg-41 col-md-6 col-sm-12">
                            <div className="testimonial-eight_inner">
                                <div className="rating">
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                </div>
                                <div className="testimonial-eight_text">
                                   “Horizon Webinfo Pvt Ltd helped us implement and customize Odoo ERP exactly as per our business process. Their Odoo ERP developers understood Indian accounting, inventory, and GST requirements very well. The system has improved our efficiency and reporting.”
                                </div>
                                <div className="testimonial-eight_author">
                                    <div className="testimonial-eight_author-image">
                                        <img src="images/resource/author-1.jpg" alt="" />
                                    </div>
                                    Mahesh Chavda
                                    {/* <span>Exceptional Service</span> */}
                                </div>
                            </div>
                        </div>
                        {/* Testimonial Seven */}
                        <div className="testimonial-eight col-lg-41 col-md-6 col-sm-12">
                            <div className="testimonial-eight_inner">
                                <div className="rating">
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                </div>
                                <div className="testimonial-eight_text">
                                   “We approached Horizon Webinfo for custom software development, and they delivered a solution that matched our workflow perfectly. The software is user-friendly, scalable, and has reduced our manual work significantly. Highly recommended IT company in India.”
                                </div>
                                <div className="testimonial-eight_author">
                                    <div className="testimonial-eight_author-image">
                                        <img src="images/resource/author-15.html" alt="" />
                                    </div>
                                    Nitin Mohitra - Dynamics Machine Pvt Ltd
                                    {/* <span>Professionalism Redefined</span> */}
                                </div>
                            </div>
                        </div>
                        {/* Testimonial Seven */}
                        <div className="testimonial-eight col-lg-41 col-md-6 col-sm-12">
                            <div className="testimonial-eight_inner">
                                <div className="rating">
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                </div>
                                <div className="testimonial-eight_text">
                                    “Our website was developed by Horizon Webinfo, and we are very satisfied with the design, speed, and SEO structure. The team created a professional and mobile-friendly website that generates regular enquiries for our business.”
                                </div>
                                <div className="testimonial-eight_author">
                                    <div className="testimonial-eight_author-image">
                                        <img src="images/resource/author-16.html" alt="" />
                                    </div>
                                    Rajesh Kothra
                                    {/* <span>ROI Booster</span> */}
                                </div>
                            </div>
                        </div>
                        {/* Testimonial Seven */}
                        <div className="testimonial-eight col-lg-41 col-md-6 col-sm-12">
                            <div className="testimonial-eight_inner">
                                <div className="rating">
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                </div>
                                <div className="testimonial-eight_text">
                                    “Horizon Webinfo automated our internal business processes, saving us time and reducing errors. Their automation solution helped us manage operations smoothly and improved overall productivity. A reliable technology partner for Indian businesses.”
                                </div>
                                <div className="testimonial-eight_author">
                                    <div className="testimonial-eight_author-image">
                                        <img src="images/resource/author-16.html" alt="" />
                                    </div>
                                    Kirtan Solanki - Magix Software
                                    {/* <span>Invaluable Expertise</span> */}
                                </div>
                            </div>
                        </div>
                        {/* Testimonial Seven */}
                        <div className="testimonial-eight col-lg-41 col-md-6 col-sm-12">
                            <div className="testimonial-eight_inner">
                                <div className="rating">
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                </div>
                                <div className="testimonial-eight_text">
                                    “We are using Horizon Webinfo’s cloud server and hosting services for our ERP and website. The server performance, security, and uptime are excellent. Their support team is responsive and always available when needed.
                                </div>
                                <div className="testimonial-eight_author">
                                    <div className="testimonial-eight_author-image">
                                        <img src="images/resource/author-17.html" alt="" />
                                    </div>
                                  Dharamraj - Dharamraj Construction Pvt Ltd
                                    {/* <span>Smooth Transition</span> */}
                                </div>
                            </div>
                        </div>
                        {/* Testimonial Seven */}
                        <div className="testimonial-eight col-lg-41 col-md-6 col-sm-12">
                            <div className="testimonial-eight_inner">
                                <div className="rating">
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                </div>
                                <div className="testimonial-eight_text">
                                   “Horizon Webinfo developed our e-commerce website with payment gateway integration and inventory management. The platform is fast, secure, and easy to manage. Our online sales have improved after launching the new
                                </div>
                                <div className="testimonial-eight_author">
                                    <div className="testimonial-eight_author-image">
                                        <img src="images/resource/author-18.html" alt="" />
                                    </div>
                                    Hardik Shah
                                    {/* <span>Expert Guidance</span> */}
                                </div>
                            </div>
                        </div>
                        {/* Testimonial Seven */}
                        <div className="testimonial-eight col-lg-41 col-md-6 col-sm-12">
                            <div className="testimonial-eight_inner">
                                <div className="rating">
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                </div>
                                <div className="testimonial-eight_text">
                                    “We have taken domain registration, hosting, and business email services from Horizon Webinfo. Everything is managed smoothly under one roof, and their support is prompt. It gives our business a professional identity.”
                                </div>
                                <div className="testimonial-eight_author">
                                    <div className="testimonial-eight_author-image">
                                        <img src="images/resource/author-18.html" alt="" />
                                    </div>
                                    Mukund Sharma
                                    {/* <span>Collaborative Success</span> */}
                                </div>
                            </div>
                        </div>
                        {/* Testimonial Seven */}
                        <div className="testimonial-eight col-lg-41 col-md-6 col-sm-12">
                            <div className="testimonial-eight_inner">
                                <div className="rating">
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                    <span className="fa fa-star" />
                                </div>
                                <div className="testimonial-eight_text">
                                    “We have been working with Horizon Webinfo Pvt Ltd for ongoing IT support and maintenance. Their team is dependable, transparent, and understands business priorities. A trusted IT service provider in Ahmedabad.”
                                </div>
                                <div className="testimonial-eight_author">
                                    <div className="testimonial-eight_author-image">
                                        <img src="images/resource/author-18.html" alt="" />
                                    </div>
                                    Kaushik Raj
                                    {/* <span>Tailored Excellence</span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Button Box */}
                    {/* <div className="button-box text-center">
                        <a className="btn-style-one theme-btn btn-item" href="#">
                            <div className="btn-wrap">
                                <span className="text-one">
                                    Load more <i className="fas fa-sync-alt fa-fw" />
                                </span>
                                <span className="text-two">
                                    Load more <i className="fas fa-sync-alt fa-fw" />
                                </span>
                            </div>
                        </a>
                    </div> */}
                </div>
            </section>

        </div>
    );
}